(function() {
    const DRAFT_ENDPOINT = "https://draft.wulihao.net/create_draft";
    const CUSTOMER_ID = window.CUSTOMER_ID;

    let draftFailCount = 0;  // 0 = first try, 1 = second try

    async function getStableCart() {
        let attempts = 0;
        let lastSubtotal = null;

        while (attempts < 5) {
            const res = await fetch('/cart.js', { credentials: 'same-origin' });
            const cart = await res.json();

            const subtotal = cart.items_subtotal_price;

            // If subtotal unchanged → Massy finished updating
            if (lastSubtotal !== null && subtotal === lastSubtotal) {
                return cart;
            }

            lastSubtotal = subtotal;
            attempts++;

            // Wait 150ms for Massy script to recalc
            await new Promise(r => setTimeout(r, 150));
        }

        // After 5 attempts, return whatever we have
        return cart;
    }

    async function createDraftAndRedirect(event) {
        event.preventDefault();
        
        const btn = event.target;
        const originalText = btn.innerText;

        btn.disabled = true;
        btn.innerText = "Loading…";

        try {
            sessionStorage.clear();
            localStorage.removeItem('shopify-checkout-contact-information');
        } catch (e) {}

        // Load stable Massy-updated cart
        let cart;
        try {
            cart = await getStableCart();
        } catch (err) {
            console.error('Failed to load stable cart', err);

            btn.disabled = false;
            btn.innerText = originalText;
            window.location.href = '/checkout';
            return;
        }

        if (!cart.items || !cart.items.length) {
            btn.disabled = false;
            btn.innerText = originalText;
            window.location.href = '/checkout';
            return;
        }
        // 👇 SHIPPING FEE CHECK (INSERT HERE)
        const subtotal = cart.items_subtotal_price / 100; // cents → dollars
        const FREE_SHIPPING_MIN = 43.00; // change to your rule
        
        function showFreeShippingModal() {
            return new Promise(resolve => {
                const modal = document.getElementById('free-shipping-modal');
                const backdrop = modal.querySelector('.fsm-backdrop');

                // 🔒 Lock background scroll
                const previousOverflow = document.body.style.overflow;
                document.body.style.overflow = 'hidden';

                modal.style.display = 'block';

                const close = (result) => {
                modal.style.display = 'none';

                // 🔓 Restore scroll
                document.body.style.overflow = previousOverflow;

                cleanup();
                resolve(result);
                };

                const cleanup = () => {
                document.getElementById('fsm-ok').onclick = null;
                document.getElementById('fsm-cancel').onclick = null;
                backdrop.onclick = null;
                };

                // Yes / Continue
                document.getElementById('fsm-ok').onclick = () => {
                close(true);
                };

                // No / Cancel
                document.getElementById('fsm-cancel').onclick = () => {
                close(false);
                };

                // Click outside = cancel
                backdrop.onclick = () => {
                close(false);
                };
            });
        }
        
        if (subtotal < FREE_SHIPPING_MIN) {
            const proceed = await showFreeShippingModal();

            if (!proceed) {
                btn.disabled = false;
                btn.innerText = originalText;
                return;
            }
        }

        // 👆 END SHIPPING CHECK
        const items = cart.items.map(i => ({
            variant_id: i.variant_id,
            product_id: i.product_id,
            price: i.original_price / 100,
            quantity: i.quantity
        }));

        const noteInput = document.querySelector('[name="note"]');
        const note = noteInput ? noteInput.value : "";

        console.log("Calling draft endpoint:", DRAFT_ENDPOINT);

        try {
            const draftRes = await fetch(DRAFT_ENDPOINT, {
                method: 'POST',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: items,
                    customer_id: CUSTOMER_ID,
                    note: note
                })
            });

            if (!draftRes.ok) {
                console.error('Draft HTTP error:', draftRes.status);

                if (draftFailCount === 0) {
                    draftFailCount = 1;
                    alert('Network unstable. Please try again.');
                    btn.disabled = false;
                    btn.innerText = originalText;
                    return;
                }
                window.location.href = '/checkout';
                return;
            }

            const data = await draftRes.json();
            console.log('Draft API response:', data);

            if (data && data.checkout_url) {
                window.location.href = data.checkout_url;
                return;
            }

            console.error('Draft error, no checkout_url:', data);

            if (draftFailCount === 0) {
                draftFailCount = 1;
                alert('Network issue. Please try again.');
                btn.disabled = false;
                btn.innerText = originalText;
                return;
            }
            window.location.href = '/checkout';

        } catch (err) {
            console.error('Error calling draft endpoint', err);

            if (draftFailCount === 0) {
                draftFailCount = 1;
                alert('Network unstable. Please try again.');
                btn.disabled = false;
                btn.innerText = originalText;
                return;
            }
            window.location.href = '/checkout';
        }
    }

    document.addEventListener('click', function(e) {
        const drawerBtn = e.target.closest('#CartDrawer-Checkout');
        const cartPageBtn = e.target.closest('button[name="checkout"], #cart-proceed-to-checkout');
        const btn = drawerBtn || cartPageBtn;
        if (!btn) return;

        createDraftAndRedirect(e);
    });
})();
